import {
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Typography,
    Box,
    TextField,
    Button,
    Grid2,
    Grid
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useMemo, useState } from "react";
import { commonHeaderStyle, commonHeaderStyle2, NoDataMatchStyles } from "../../assets/styles/CommonStyles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import CustomBackdrop from "../backdrop/CustomBackdrop";
const dialogColumnsLastMonth = [
    // { field: "code", header: "Code" },
    //{ field: "description", header: "Description" },
    { field: "invoiceNumber", header: "Invoice Number" },
    { field: "createdDate", header: "Created Date" },
    { field: "approvedDate", header: "Approved Date" },
    //{ field: "feeStageID", header: "Fee Stage ID" },
    { field: "amountToInvoice", header: "Amount To Invoice" },
    { field: "amountToCredit", header: "Amount To Credit" },
    { field: "creditNoteReason", header: "Credit Note Reason" },

    { field: "amountToAFPAccural", header: "AFP Accrual" },
    { field: "amountToAFPRelease", header: "AFP Release" },
    { field: "amountToAFPWriteOff", header: "AFP Write-Off" },

    { field: "amountToWIPAccrual", header: "WIP Accrual" },
    { field: "amountToWIPRelease", header: "WIP Release" },
    { field: "amountToWIPWriteOff", header: "WIP Write Off" },
    { field: "wipReason", header: "Wip Reason" },
    { field: "wipWriteOffReason", header: "WIP Write-Off Reason" },
    { field: "amountToPrebillAccural", header: "Prebill Accrual" },
    { field: "amountToPrebillRelease", header: "Prebill Release" },
    { field: "amountToPrebillWriteOff", header: "Prebill Write-Off" },
    { field: "prebillReason", header: "Prebill Reason" },
    { field: "prebillWriteOffReason", header: "Prebill Write-Off Reason" }
];
const dialogColumnsAFP = [
    { field: "invoiceNumber", header: "Invoice Number" },
    { field: "createdOn", header: "Created Date" },
    { field: "amountInAFP", header: "Amount In AFP" },
    { field: "afpNumber", header: "AFP Number" },
    { field: "createdBy", header: "Submitted By" },
    { field: "approvedBy", header: "Approved By" }

];




const InvoiceDetailsDialog = ({
    loading,
    open,
    onClose,
    data,
    GetFeeStageDetails,
    CurrentFeestageID,
    projectID,
    SectionId,
    FeestageIDs,
    invoiceId
}: any) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentFeeStage, setCurrentFeeStage] = useState("");
    const [currentDescription, setCurrentDescription] = useState("");
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [searchValue, setSearchValue] = useState("");
    const fixedColumns = ["invoiceNumber", "createdDate", "approvedDate", "amountToInvoice"];

   
    const dialogColumns = useMemo(() => {
       
        switch (SectionId) {
            case 3:
                return dialogColumnsLastMonth;
            case 5:
                return dialogColumnsAFP ;
            default:
                return[];
        }

    }, [SectionId]);
    
    const getLeftOffset = (field: string) => {
        let left = 0;
        for (const col of dialogColumns) {
            if (col.field === field) break;
            if (fixedColumns.includes(col.field)) {
                left += 150;
            }
        }
        return left;
    };


    useEffect(() => {

        if (data?.length > 0) {
            setCurrentFeeStage(data[0].code);
            setCurrentDescription(data[0].description);
            setFilteredData(data);
        }
    }, [data]);


    const getNext = () => {
        if (currentIndex < FeestageIDs.length - 1) {
            const nextIndex = currentIndex + 1;
            setCurrentIndex(nextIndex);

            const nextFeeStageId = FeestageIDs[nextIndex];
            GetFeeStageDetails(nextFeeStageId, projectID,invoiceId);
        }
    };
    const getPrevious = () => {
        if (currentIndex > 0) {
            const prevIndex = currentIndex - 1;
            setCurrentIndex(prevIndex);

            const prevFeeStageId = FeestageIDs[prevIndex];
            GetFeeStageDetails(prevFeeStageId, projectID,invoiceId);
        }
    };

    useEffect(() => {
        const x = FeestageIDs.indexOf(CurrentFeestageID);
        setCurrentIndex(x >= 0 ? x : 0);
    }, [CurrentFeestageID, FeestageIDs, open]);


    const filterData = () => {
        if (!data) {
            setFilteredData([]);
            return;
        }
        const result = data.filter((row: any) => {

            // 🔍 Text search
            const matchesText =
                !searchValue ||
                Object.values(row).some(value =>
                    String(value).toLowerCase().includes(searchValue.toLowerCase())
                );

            // 📅 Date filter
            const rowDate = new Date(row.createdDate);

            const matchesStart =
                !startDate ||
                rowDate.toDateString() === startDate.toDate().toDateString();

            return matchesText && matchesStart;
        });

        setFilteredData(result);
    };

    useEffect(() => {
        filterData();
    }, [searchValue, startDate, data]);

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
                onClose();
            }}
            maxWidth="xl"
            fullWidth
            PaperProps={{
                sx: {
                    height: "80vh",
                    maxHeight: "80vh",
                }
            }}
        >

            {/* Title */}
            <DialogTitle
                sx={{
                    px: 2,
                    py: 1.5,
                    borderBottom: "1px solid #e0e0e0"
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}
                >

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <IconButton
                            onClick={getPrevious}
                            disabled={currentIndex === 0}
                            size="small"
                            color="primary"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <IconButton
                            onClick={getNext}
                            disabled={currentIndex === FeestageIDs.length - 1}
                            size="small"
                            color="primary"
                        >
                            <ArrowForwardIcon />
                        </IconButton>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "green"
                            }}
                        >
                            Last Month Invoices:

                            <Typography variant="h6" sx={{ fontWeight: 400, color: "red" }}>
                                {currentFeeStage}<span style={{ color: "black" }}> - {currentDescription}</span>
                            </Typography>
                        </Typography>

                    </Box>

                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>

                </Box>
            </DialogTitle>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 1.5,
                    borderRadius: 2,
                    // width: "100%",
                    marginLeft:"10px"
                }}
            >
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search..."
                    variant="outlined"
                    sx={{
                        backgroundColor: "#fff",
                        borderRadius: 1,
                        maxWidth: 600,

                    }}
                    onChange={(e) => { setSearchValue(e.target.value) }}
                />
                <Grid item xs={12} md={3}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format="DD/MM/YYYY"
                            label="Created Date"
                            value={startDate}
                            slotProps={{
                                textField: { fullWidth: true, size: "small" }
                            }}
                            onChange={(newValue) => {
                                setStartDate(newValue);
                            }}
                        />
                    </LocalizationProvider>
                </Grid>
            </Box>
            {/* Content */}
            <DialogContent
                sx={{
                    height: "calc(80vh - 100px)",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <Box sx={{ maxHeight:"calc(70vh - 100px)",overflow: "auto" }}>
                    <Table size="small" stickyHeader
                        sx={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                            minWidth: "1500px",
                            width: "max-content",
                        }}
                    >
                        <TableHead>
                            <TableRow sx={commonHeaderStyle2} >
                                {dialogColumns.map(col => (
                                    <TableCell
                                        key={col.field}
                                        sx={{
                                            minWidth:150,
                                            maxWidth:150,

                                            ...(fixedColumns.includes(col.field)
                                                ? {
                                                    position: "sticky",
                                                    left: getLeftOffset(col.field),
                                                    top: 0,
                                                    zIndex: 4,
                                                    background: "#f5f5f5",
                                                }
                                                : {
                                                    position: "sticky",
                                                    zIndex: 2,
                                                }),
                                        }}
                                    >
                                        {col.header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.length > 0 ?
                                filteredData?.map((row: any, index: number) => (
                                    <TableRow key={index}>
                                        {dialogColumns.map(col => {
                                            let value = row[col.field];

                                            if (col.field === "createdDate" || col.field === "approvedDate" || col.field === "createdOn") {
                                                const d = new Date(value);
                                                value = d.toLocaleDateString() + " " + d.toLocaleTimeString();
                                            }

                                            return (
                                                <TableCell
                                                    key={col.field}
                                                    sx={{
                                                        minWidth: 150,
                                                        maxWidth: 150,

                                                        ...(fixedColumns.includes(col.field) && {
                                                            position: "sticky",
                                                            left: getLeftOffset(col.field),
                                                            zIndex: 2,
                                                            background: "#fff",
                                                        }),
                                                    }}
                                                >
                                                    {value ?? 0}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                )) :
                                <TableRow>
                                    <TableCell colSpan={dialogColumns.length} >
                                        <Typography sx={NoDataMatchStyles}>
                                            No data matching the search criteria
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>

                    </Table>
                </Box>
            </DialogContent>
            <CustomBackdrop open={loading} />
        </Dialog>
    );
};
export default InvoiceDetailsDialog;